import { CallAPI } from "../../apiManager/ApiCall";
import {
  getQuizResultGroupByDateURL,
  quizContentRandomURL,
  quizContentURL,
  quizResultURL,
  quizTitleURL,
} from "../../apiManager/APIConfig";

export const AddQuizTitlesCall = async (body) => {
  try {
    const response = await CallAPI({
      url: `${quizTitleURL}`,
      method: "POST",
      body, // ✅ send title & body
    });
    return response;
  } catch (error) {
    return { status: 400, message: "Failed to add quiz title" };
  }
};
export const EditQuizTitlesCall = async (body) => {
  try {
    const response = await CallAPI({
      url: `${quizTitleURL}`,
      method: "PUT",
      body, // ✅ send title & body
    });
    return response;
  } catch (error) {
    return { status: 400, message: "Failed to add quiz title" };
  }
};
export const DeleteQuizTitlesCall = async (body) => {
  try {
    const response = await CallAPI({
      url: `${quizTitleURL}`,
      method: "DELETE",
      body, // ✅ send title & body
    });
    return response;
  } catch (error) {
    return { status: 400, message: "Failed to add quiz title" };
  }
};

/**
 * GET quiz titles for a given language and type.
 * `type` is optional and defaults to "histology" so any pre-existing
 * call site that didn't pass a type keeps producing the exact same
 * request as production today.
 */
export const GetQuizTitlesCall = async ({ title, lang, image = null, type = "histology" }) => {
  try {
    const safeType = encodeURIComponent((type || "histology").trim());
    const response = await CallAPI({
      url: `${quizTitleURL}?lang=${lang}&type=${safeType}`,
      method: "GET",
    });
    return response;
  } catch (error) {
    return { status: 400, message: "Failed to add quiz title" };
  }
};

export const GetAllQuizByIdCall = async (title_id, lang) => {
  try {
    const response = await CallAPI({
      url: `${quizContentRandomURL}?title_id=${title_id}&lang=${lang}`,
      method: "GET",
    });
    return response?.data;
  } catch (error) {
    return { status: 400, message: "Failed to add quiz title" };
  }
};

export const AddQuizContentByIdCall = async (body) => {
  try {
    console.log("pippo body", body);

    const response = await CallAPI({
      url: `${quizContentURL}`,
      method: "POST",
      body,
    });
    return response?.data;
  } catch (error) {
    return { status: 400, message: "Failed to add quiz title" };
  }
};
export const AddEditQuizTranslationCall = async (body) => {
  try {
    const response = await CallAPI({
      url: `${quizContentURL}`,
      method: "POST",
      body,
    });
    return response?.data;
  } catch (error) {
    return { status: 400, message: "Failed to add quiz title" };
  }
};

export const EditQuizContentByIdCall = async (body) => {
  try {
    console.log("pippo edit body", body);

    const response = await CallAPI({
      url: `${quizContentURL}`,
      method: "PUT",
      body,
    });
    return response?.data;
  } catch (error) {
    return { status: 400, message: "Failed to add quiz title" };
  }
};

export const DeleteQuizContentByIdCall = async (body) => {
  try {
    console.log("pippo body", body);

    const response = await CallAPI({
      url: `${quizContentURL}`,
      method: "DELETE",
      body,
    });
    return response?.data;
  } catch (error) {
    return { status: 400, message: "Failed to add quiz title" };
  }
};

export const ResultQuizCall = async (body) => {
  try {
    const response = await CallAPI({
      url: `${quizResultURL}`,
      method: "POST",
      body,
    });
    return response;
  } catch (error) {
    return { status: 400, message: "Failed to save quiz result" };
  }
};

export const GetQuizResultByDateCall = async () => {
  try {
    const response = await CallAPI({
      url: `${getQuizResultGroupByDateURL}`,
      method: "GET",
    });
    return response;
  } catch (error) {
    return { status: 400, message: "Failed to load quiz history" };
  }
};
